import React, { useState } from 'react'
import styled from 'styled-components'
import get from 'lodash/get'

import { useGetAdventureReviewsQuery } from 'hooks/useQueries'
import ReviewsModal from 'components/reviews/ReviewsModal'
import ReviewList from 'components/reviews/ReviewList'
import ReviewScore from 'components/reviews/ReviewScore'
import Button from 'components/display/Button'
import { SectionTitle } from '../../listing/Sections/shared'
import { Section } from '../shared'

const Spacer = styled.div`
  margin-bottom: 40px;
`

interface ReviewsProps {
  adventureId: string
  score?: string
}

const Reviews = ({ score, adventureId }: ReviewsProps) => {
  const [reviewsModalOpen, setReviewsModalOpen] = useState(false)
  const { data, loading } = useGetAdventureReviewsQuery({
    fetchPolicy: 'no-cache',
    variables: {
      id: adventureId,
    },
  })

  const reviewsConnection = get(data, 'adventure.reviews')
  const hasNextPage = get(data, 'adventure.reviews.pageInfo.hasNextPage')

  if (reviewsConnection && reviewsConnection.edges.length === 0) {
    return null
  }

  return (
    <Section>
      <SectionTitle>Reviews</SectionTitle>
      <ReviewScore score={score} size="medium" />
      <Spacer />

      <ReviewList loading={loading} reviewsConnection={reviewsConnection} />

      {hasNextPage && (
        <Button
          onClick={() => setReviewsModalOpen(true)}
          ghost
          uppercase={false}
          style={{ margin: '30px auto 0 auto' }}
        >
          See all reviews
        </Button>
      )}

      <ReviewsModal
        reviewType="adventure"
        reviewScore={score}
        typeId={adventureId}
        isOpen={reviewsModalOpen}
        onRequestClose={() => {
          setReviewsModalOpen(false)
        }}
      />
    </Section>
  )
}

export default Reviews
